import {useContext, useEffect} from 'react'
import {GlobalContext} from '../context/DataContext'
import ApiService from '../../common/ApiCalls'

export const useNotification = async () => {
    const userId = localStorage.getItem('userId')
    const {dataManagementNotificationCount: dataManagementNotificationCountContext} = useContext(GlobalContext)
    const [, setDataManagementNotificationCount] = dataManagementNotificationCountContext

    useEffect( ()=>{
        try{
            const fetchCount = async () => {
                const res = await ApiService().getTotalPendingByUserId(userId)
                if(res>0){
                    setDataManagementNotificationCount(res)
                }
            }
            fetchCount()
        }catch{
            console.log('There was an error: useNotification')
        }
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [])
}